import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { NumberProvider } from './context/NumberContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <NumberProvider>
      <App />
    </NumberProvider>
  </React.StrictMode>
);
